import Navbar from "../components/NavBar";
import { Footer } from "./_components/FooterSection";
import { HeroSection } from "./_components/HeroSection";
import { RecentProjectsSection } from "./_components/RecentProjectsSection";
import { SkillsSection } from "./_components/SkillsSection";
import { WorkExperienceSection } from "./_components/WorkExperienceSection";
import { Element } from "react-scroll";
import { PageTransition } from "../components/ui/PageTransition";

export const HomePage = () => {
    return (
        <PageTransition>
            <div className="flex flex-col gap-12 w-full">
                <Navbar />

                <div className="px-10 flex flex-col gap-12">
                    {/* Hero Section */}
                    <Element
                        name="hero"
                        className="element pt-2 pb-4"
                    >
                        <HeroSection />
                    </Element>
                    {/* WorkExperienceSection */}
                    <Element
                        name="experience"
                        className="element py-4"
                    >
                        <WorkExperienceSection />
                    </Element>
                    {/* RecentProjectSection */}
                    <Element
                        name="projects"
                        className="element py-4"
                    >
                        <RecentProjectsSection />
                    </Element>
                    {/* Skills Section */}
                    <Element
                        name="skills"
                        className="element py-4"
                    >
                        <SkillsSection />
                    </Element>
                </div>
                {/* FooterSection */}
                <Footer />
            </div>
        </PageTransition>
    );
};
